import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-label": "Location Details",
  itemtype: "http://schema.org/Restaurant",
  class: "ion-no-padding",
  style: {"height":"90%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_hereMap = _resolveComponent("hereMap")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_locationLineItem = _resolveComponent("locationLineItem")!
  const _component_orderType = _resolveComponent("orderType")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_ctx.slug)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_ion_toolbar, {
          mode: "ios",
          color: "white",
          class: "modal-toolbar"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              slot: "end",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              fill: "clear",
              color: "medium",
              class: "detail-btn",
              "data-cy": "button-close"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  md: _ctx.closeOutline,
                  ios: _ctx.closeOutline
                }, null, 8, ["md", "ios"])
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "ion-text-center bold color-black" }, "Location Details", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            (_ctx.showMap)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 0,
                  class: "detail-map"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { class: "pa-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_hereMap, { class: "map" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.detail)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 1,
                  style: {"margin-bottom":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "px-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_locationLineItem, {
                          storeLocation: _ctx.detail,
                          detail: ""
                        }, null, 8, ["storeLocation"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      class: "ion-text-center",
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_orderType, { storeLocation: _ctx.detail }, null, 8, ["storeLocation"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, {
          class: "ion-no-margin force-bottom full-width buttons-toolbar",
          style: {"position":"absolute"}
        }, {
          default: _withCtx(() => [
            (!_ctx.detail?.isTempClosed)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  color: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPickupLocation(_ctx.detail))),
                  expand: "full",
                  class: "ion-no-margin full-width",
                  size: "large",
                  disabled: !_ctx.detail?.id,
                  "data-cy": "button-pickup",
                  id: "button-pickup"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isRedRobinStore ? 'Order At Red Robin' : 'Pick up here'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.detail?.isTempClosed && !_ctx.isRedRobinStore)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 1,
                  color: "primary",
                  fill: "clear",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchToDelivery())),
                  expand: "full",
                  class: "ion-no-margin full-width",
                  size: "large",
                  disabled: !_ctx.detail?.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isRedRobinStore ? 'Order At Red Robin' : 'Order Delivery'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}